// extracted by mini-css-extract-plugin
export default {"cardIcon":"rocket_cardIcon__tHMEC","article":"rocket_article__QkyKk","nameStatus":"rocket_nameStatus__5uowo","name":"rocket_name__zy4DN","details":"rocket_details__tC6Re"};